import React, { useEffect, useState } from 'react'
import Header from '../../components/generals/header'
import stylesIndex from '../../css/Index.module.css'
import store from '../../reducer/store'
import DataTableDemo from '../../components/generals/datatables/datatable'
import { getData } from '../../actions/servicesHttp'
import { formatDate } from '../../components/generals/charts/utils/DatesFormats'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function SoftwareEvents () {
  const { t } = useTranslation('softwareEvents')
  const { user } = store.getState()
  const role = user.roles
  const [urlSoftwareEvents] = useState('events/softwareEvents')
  const [events, setEvents] = useState()
  const navigate = useNavigate()

  const columns = [
    { field: 'identity', header: t('headers.one') },
    { field: 'serial_number', header: t('headers.two') },
    { field: 'so', header: t('headers.three') },
    { field: 'type', header: t('headers.four') },
    { field: 'date', header: t('headers.five') },
    { field: 'ip_wan', header: t('headers.six') },
    { field: 'data', header: t('headers.seven') }
  ]

  const getSoftwareEvents = async () => {
    const response = await getData(urlSoftwareEvents, undefined, navigate)

    if (response?.status === 200) {
      const events = response?.data

      events.forEach((info) => {
        const device = info.device
        info.identity = device.identity
        info.serial_number = device.serial_number
        info.data = JSON.stringify(info.data)

        const soSplit = device?.so?.split('_-_') || []
        const so = soSplit.length > 1 ? `${soSplit[0]} ${soSplit[1]}` : soSplit[0] || ''
        info.so = so

        info.date = info.date === null ? t('noDisponible') : formatDate(info.date)
        delete info.device
      })
      setEvents(events)
    } else {
      setEvents([])
    }
  }

  useEffect(() => {
    getSoftwareEvents()
  }, [])

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <div style={{ marginTop: '1rem' }}>
          <DataTableDemo
            data={events}
            reload={() => getSoftwareEvents()}
            editUsers={false}
            rowStates={false}
            rowSelecteds={false}
            exportsPdf={role?.softwareEventsPage.exportPdf}
            exportsCsv={role?.softwareEventsPage.exportCsv}
            actionDelete={false}
            actionDashboard={false}
            table="softwareEvents"
            searchs={['serial_number', 'identity', 'type', 'so', 'ip_wan']}
            columns={columns}
            namePdf={t('namePdf')}
          />
        </div>
      </div>
    </div>
  )
}
